function setfooterimgswidth() {
  $('.footer-images-animate').each(function() {
    var footerel = this; 
    var initialfooteritems = $(this).find('.initialimages');
    var footermarqueewidth = $(footerel).width();
    var initialfooterwidth = $(initialfooteritems).width();
    $(footerel).attr('data-width', `${footermarqueewidth}`).attr('data-initial-width', `${initialfooterwidth}`);
    animatefooter(footerel,initialfooterwidth,footermarqueewidth)
  })
}

$(function () {
  setfooterimgswidth();
});

window.addEventListener("resize", setfooterimgswidth);


function animatefooter(footerel,initialfooterwidth,footermarqueewidth) {

speed = $(footerel).find('.footer-image-item').length * 2500;

animatedmarquee = footerel.animate([
  { transform: 'translateX(0)' }, 
  { transform: `translateX(-${initialfooterwidth/2}px)` }
], {
  duration: speed,
  iterations: 999999
}) 
}